import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer className="bg-primary text-white mt-10">
            <div className="max-w-screen-xl mx-auto px-4 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
                <div className="flex gap-6 text-sm md:text-base">
                    <Link to="/" className="hover:underline">
                        Home
                    </Link>
                    <Link to="/ordermanagement" className="hover:underline">
                        Orders
                    </Link>
                    <Link to="/messagemanagement" className="hover:underline">
                        Messages
                    </Link>
                    <Link to="/productmanagement" className="hover:underline">
                        Products
                    </Link>
                </div>
                <div className="text-sm text-white/80">&copy; {new Date().getFullYear()} Store</div>
            </div>
        </footer>
    );
}